import cardsSlice from './cards/cardsSlice';
import customersSlice from './customers/customersSlice';
import destPointSlice from './destPoint/destPointSlice';
import driversSlice from './drivers/driversSlice';
import productsSlice from './products/productsSlice';
import resultsSlice from './results/resultsSlice';
import settingsSlice from './settings/settingsSlice';
import vehiclesSlice from './vehicles/vehiclesSlice';
import weightingsSlice from './weightings/weightingsSlice';

const reduxSlicesList = {
 results: resultsSlice.actions,
 customers: customersSlice.actions,
 drivers: driversSlice.actions,
 vehicles: vehiclesSlice.actions,
 weightings: weightingsSlice.actions,
 products: productsSlice.actions,
 destPoint: destPointSlice.actions,
 cards: cardsSlice.actions,
 settings: settingsSlice.actions,
};

export default reduxSlicesList;

